import { useEffect, useState } from 'react';

export enum OperatingSystemType {
  // eslint-disable-next-line no-unused-vars
  WINDOWS = 'Windows',
  // eslint-disable-next-line no-unused-vars
  MAC = 'macOS',
  // eslint-disable-next-line no-unused-vars
  IOS = 'iOS',
  // eslint-disable-next-line no-unused-vars
  ANDROID = 'Android',
  // eslint-disable-next-line no-unused-vars
  LINUX = 'Linux',
  // eslint-disable-next-line no-unused-vars
  UNKNOWN = 'Unknown',
}

export const useOperatingSystem = (): OperatingSystemType => {
  const [osType, setOsType] = useState<OperatingSystemType>(
    OperatingSystemType.UNKNOWN,
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;

    if (/Windows/.test(userAgent)) {
      setOsType(OperatingSystemType.WINDOWS);
    } else if (/Macintosh|MacIntel|MacPPC|Mac68K|macOS/.test(platform)) {
      setOsType(OperatingSystemType.MAC);
    } else if (/iPhone|iPad|iPod/.test(userAgent)) {
      setOsType(OperatingSystemType.IOS);
    } else if (/Android/.test(userAgent)) {
      setOsType(OperatingSystemType.ANDROID);
    } else if (/Linux/.test(platform)) {
      setOsType(OperatingSystemType.LINUX);
    }
  }, []);

  return osType;
};

export default useOperatingSystem;
